import React, { FunctionComponent } from 'react';

import cover from 'polished/lib/mixins/cover';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import SketchedCircles from './SketchedCircles';

export interface CircledTitleProps extends FlexProps<'div'> {
  children?: string;
}

const useStyles = () => {
  const { spacing, colors } = useTheme();
  const {
    button: { accent },
  } = usePalette();
  return {
    root: {
      position: 'relative',
    },
    circles: {
      ...cover(),
      color: colors[accent],
      overflow: 'visible',
    },
    title: {
      textAlign: 'center',
      marginTop: spacing(1),
      zIndex: 1,
    },
  } as const;
};

const CircledTitle: FunctionComponent<CircledTitleProps> = (props) => {
  const { children, ...other } = props;
  const classes = useStyles();

  return (
    <Flex
      css={classes.root}
      padding={[4, 6, 6]}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      {...other}
    >
      <SketchedCircles css={classes.circles} height="100%" width="100%" />
      <Text css={classes.title} as="h2" variant="headline1" align="center">
        {children}
      </Text>
    </Flex>
  );
};

export default CircledTitle;
